import loadable from '@loadable/component';

export const NewbuildingPromoCarouselContainerLoadable = loadable(() =>
  import('./NewbuildingPromoCarousel').catch(/* istanbul ignore next */ () => ({ default: () => null })),
);
